export default __webpack_public_path__ + "static/media/error-icon.7ac19de9.png";